module.exports = __webpack_public_path__ + "img/work.162de148.svg";